import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UIState } from './ui.reducer';

export const UIKey = 'ui';

export const getUiState = createFeatureSelector<UIState>(UIKey);

export const getTheme = createSelector(getUiState, (state) => state.theme);
